import { format, parseISO } from 'date-fns';
import { enUS, ptBR } from 'date-fns/locale';
import type { Grain } from './filters';

export function dateFnsLocale(language: string | undefined) {
  return language?.startsWith('pt') ? ptBR : enUS;
}

/** Axis/table label for a time bucket key ('yyyy-mm-dd') at the given grain. */
export function formatBucket(bucket: string, grain: Grain, language?: string): string {
  const date = parseISO(bucket);
  const locale = dateFnsLocale(language);
  if (grain === 'month') return format(date, 'MMM yy', { locale });
  return format(date, 'd MMM', { locale });
}

export function formatDate(iso: string | null | undefined, language?: string): string {
  if (!iso) return '—';
  return format(parseISO(iso), 'd MMM yyyy', { locale: dateFnsLocale(language) });
}

export function formatDateTime(iso: string | null | undefined, language?: string): string {
  if (!iso) return '—';
  return format(parseISO(iso), 'd MMM yyyy, HH:mm', { locale: dateFnsLocale(language) });
}

export function formatRate(value: number | null | undefined, digits = 0): string {
  if (value === null || value === undefined) return '—';
  return `${value.toFixed(digits)}%`;
}

export function formatNumber(value: number | null | undefined, language?: string): string {
  if (value === null || value === undefined) return '—';
  return new Intl.NumberFormat(language?.startsWith('pt') ? 'pt-BR' : 'en-US').format(value);
}
